import { Separator } from '@ais-ui/ui-core';
import { SatelliteIcon } from '@ais-ui/ui-core';
import { PiCaretUpThin, PiDiamondThin, PiThermometer } from 'react-icons/pi';
import React, { useEffect, useState } from 'react';
import { LegendColor, useMapLegendColors } from '@ais-ui/websockets';

import { LegendItem } from './LegendItem';

export const ColorByShipType = () => {
  const nonShipLegendTypeValues = [
    'Base Station',
    'AtoN',
    'MetHydro',
    'SAR Airborne',
    'Aircraft',
    'Satellite',
    'Geographic Notice',
    'Waterways Management',
    'Receiver',
    'DAS',
  ];
  const [displayLegendItems, setDisplayLegendItems] = useState<LegendColor[]>(
    [],
  );

  const { data: legendColors } = useMapLegendColors();

  useEffect(() => {
    // Sort legendColors alphabetically by name before setting to state
    const sortedLegendColors = [...(legendColors || [])].sort((a, b) =>
      a.name.localeCompare(b.name),
    );
    setDisplayLegendItems(sortedLegendColors);
  }, [legendColors]);

  return (
    <div className={'grid grid-cols-[3fr_1.1fr] bg-background relative'}>
      <div className="p-4 grid grid-cols-3 gap-4 bg-background">
        {displayLegendItems.map((item) => {
          if (!nonShipLegendTypeValues.includes(item.name)) {
            return (
              <LegendItem
                key={item.name}
                category={item.name}
                color={item.color}
              />
            );
          }
        })}
      </div>
      <div>
        <Separator
          className="mt-4 h-[400px]"
          orientation="vertical"
        ></Separator>
        <div className="p-4 grid grid-cols-1 gap-4 bg-background col-start-2 absolute top-0 left-2">
          {nonShipLegendTypeValues.map((item) => {
            let tmp_legend_color = null;
            let tmp_legend_icon = null;
            let tmp_legend_icon_color = null;
            if (item === 'Base Station') {
              tmp_legend_color = '#FFFF00';
            } else if (item === 'AtoN') {
              tmp_legend_icon = PiDiamondThin;
            } else if (item === 'MetHydro') {
              tmp_legend_icon = PiThermometer;
            } else if (item === 'SAR Airborne') {
              tmp_legend_icon_color = '#272781';
              tmp_legend_icon = PiCaretUpThin;
            } else if (item === 'Satellite') {
              tmp_legend_icon = SatelliteIcon;
            }

            if (tmp_legend_color) {
              return (
                <LegendItem
                  key={item}
                  category={item}
                  color={tmp_legend_color}
                />
              );
            } else {
              return (
                <LegendItem
                  key={item}
                  category={item}
                  icon={tmp_legend_icon}
                  iconColor={tmp_legend_icon_color}
                />
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};
